// extracted by mini-css-extract-plugin
module.exports = {"scroll-button":"scroll-button_scroll-button__1u2wL","fadeOut":"scroll-button_fadeOut__3xC_S","fadeIn":"scroll-button_fadeIn__SmrHO"};